import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable, throwError} from 'rxjs';
import {CustomsValidators} from '../../validators/custom.validators';

@Injectable({
  providedIn: 'root'
})
export class CardApproverService {
  urlCardApprover: string;
  urlCardRequestDetail: string;
  urlCardDetail: string;

  constructor(private http: HttpClient) {
    this.urlCardRequestDetail = `${environment.bffBaseUrl}/pages/card-detail-approver/`;
    this.urlCardApprover = `${environment.bffBaseUrl}/pages/card-approver-list`;
    this.urlCardDetail = `${environment.bffBaseUrl}/pages/card-detail`;
  }

  getallcardapprover(page, limit, filterUrl) {
    const urlBuilder = `${this.urlCardApprover}?page=${page}&limit=${limit}${filterUrl}`;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getImage(requestCard, mdmid): Observable<any> {
    //    const headersObject = new HttpHeaders().set("AzureToken", this.oauthService.getAccessToken())
    const urlBuilder = `${environment.bffBaseUrl}/pages/card-detail/${requestCard}/download?img=${mdmid}`;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder, {responseType: 'blob' as 'json'})
      : throwError(CustomsValidators.msgNotValidUrl);

  }

  getAllImage(requestCard) {
    //  const headersObject = new HttpHeaders().set("AzureToken", this.oauthService.getAccessToken())
    const urlBuilder = `${environment.bffBaseUrl}/pages/card-detail/${requestCard}/download?all=true`;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder, {responseType: 'blob' as 'json'})
      : throwError(CustomsValidators.msgNotValidUrl);
  }


  AproveRequestCard(ID): Observable<any> {
    const urlBuilder = this.urlCardRequestDetail + ID;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.patch(urlBuilder, {}) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getCard(ID): Observable<any> {
    const urlBuilder = this.urlCardRequestDetail + ID;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }


}
